import React from 'react';
import { useParams } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import StickyHeader from 'pages/provisioning/_components/StickyHeader';
import { Approvals } from 'pages/user-preferences/components/approvals';
import Rules from './components/rules';
import Delegates from './components/delegates';

const UserPreferences = () => {
    const { operation } = useParams();
    return (
        <>
            <Helmet>
                <title>User Preferences</title>
            </Helmet>
            {operation === 'create' || operation === 'edit' ? (
                <Approvals />
            ) : (
                <>
                    <StickyHeader title="User Preferences" />
                    <Rules />
                    <Delegates />
                </>
            )}
        </>
    );
};

export default UserPreferences;
